import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { NotificationService, DialogModalService, LanguageService } from 'src/app/services';
import { ApispecificationService } from 'src/app/services/api-specifications.service';
import { ApiUserOrgRolesService } from 'src/app/services/api-user-org-roles.service';

@Component({
  selector: 'app-specifications-list',
  templateUrl: './specifications-list.component.html',
  styleUrls: ['./specifications-list.component.css']
})
export class SpecificationsListComponent implements OnInit {

  specifications: any[] = [];
  paginationInput: any;
  paginationOutput: PaginationPageEvent;
  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  listParams: ListParams;
  language: string;
  loading: boolean;

  constructor(
    public ngProgress: NgProgress,
    private notification: NotificationService,
    private apiUserOrgService: ApiUserOrgRolesService,
    private apiSpecificationsService: ApispecificationService,
    private dialogModal: DialogModalService,
    private languageService: LanguageService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  /**
  * 
  */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.specifications = [];

    this.setListParams();

    this.apiSpecificationsService.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getSpec: ', response);

      if (response != null && response.result.list != null) {

        this.specifications = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {

      filter: {
        name: '',
        lang_code: '',
        sort_by: '',
        direction: ''
      },
      // name: "",
      // lang_code: "rus",
      // sort: {
      //   sort_by: "",
      //   directon: ""
      // },
      // object: "specification",
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
  * 
  * @param ids 
  */
  onConfirm(ids: string[], type:string) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids, type);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
  * 
  * @param ids 
  */
  onDelete(ids: string[], type): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiSpecificationsService.delete( type == 'all' ? { id: ids } : { id: [ids] }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.specifications.filter(val => val.checked).map(({ id }) => id))];
    this.onConfirm(ids, 'all');
  }

  /**
   * 
   */
  onCreate() {

    this.router.navigate(['specifications', 'create']);
  }

  /**
* 
* @param event PaginationPageEvent
*/
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.specifications[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.specifications.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if(this.specifications) {

      if (this.specifications.length == 0) return false;

      return this.specifications.every(p => p.checked);
    }
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    if(this.specifications) {

      let pl = this.specifications.length;
      let pc = this.specifications.filter(val => val.checked).length;
  
      return (pc > 0 && pc < pl) ? true : false;
    }
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    if(this.specifications) {

      let pc = this.specifications.filter(val => val.checked).length;

      return (pc > 0) ? true : false;
    }
  }

}
